import moment from 'moment'
import React from 'react'

const SalesInvoiceReportFooter = ({ footerData }) => {
  return (
    <div className="__footer">
      <table width="100%">
        <tbody>
          <tr>
            <td>
              <div style={{ float: "left", fontSize: "14px", paddingBottom: "10px" }}>
                Due Date: {footerData && moment(footerData.due_date).format('MM/DD/YYYY')}
              </div>
            </td>
          </tr>
          {footerData?.term === "CREDIT CARD" ?
            <tr>
              <td width="33.33%" />
              <td width="33.33%" />
              <td width="33.33%">
                <MyCard heading="Terms & Conditions">
                  <p>
                    1) No Return of goods after 15 days of shipment.
                    <br />
                    2) Damaged goods must be returned within 10 days
                    of shipment.
                    <br />
                    3) No Returns will be accepted without RA #.
                    <br />
                    4) Returns without an advance shipping notice (including tracking#) and an approved RA# will not be processed.
                  </p>
                </MyCard>
              </td>
            </tr>
            : footerData && (footerData.term === "WIRE TRANSFER" || footerData.term === "CONSIGNMENT" || footerData.term === "PRE-PAYMENT" || footerData.factor_id == 2) ?
              <tr>
                <td width="33.33%" style={{ height: 0, verticalAlign: "top" }}>
                  <MyCard heading="Remit Payment To">
                    <p>
                      Customer Send Payment To:
                      <br />
                      DLPD CANADA LTD.
                      <br />
                      15 Wertheim Court, Suite 409,
                      <br />
                      Richmond Hill, ON L4B 3H7,
                      <br />
                      Canada
                    </p>
                  </MyCard>
                </td>
                <td width="33.33%" style={{ height: 0, verticalAlign: "top" }}>
                  <MyCard heading="Customer Wire Payment To:">
                    <p>
                      TD Canada Trust
                      <br />
                      Address : 77 Bloor Street West Toronto, Ontario M5S 1M2 Canada
                      <br />
                      Account Number : 11042-004-5325371
                      <br />
                      Swift Code : TDOMCATTTOR
                    </p>
                  </MyCard>
                </td>
                <td width="33.33%" style={{ height: 0, verticalAlign: "top" }}>
                  <MyCard heading="Terms & Conditions">
                    <p>
                      1) No Return of goods after 15 days of shipment.
                      <br />
                      2) Damaged goods must be returned within 10 days
                      of shipment.
                      <br />
                      3) No Returns will be accepted without RA #.
                      <br />
                      4) Returns without an advance shipping notice (including tracking#) and an approved RA# will not be processed.
                    </p>
                  </MyCard>
                </td>
              </tr>
              : footerData && footerData.factor_id == 1 ?
                <tr>
                  <td width="33.33%" style={{ height: 0, verticalAlign: "top" }}>
                    <MyCard>
                      <p style={{ textAlign: "center" }}>
                        This Invoice has been sold or assigned to
                        <br />
                        THE CIT GROUP / COMMERCIAL SERVICES INC.
                        <br />
                        P.O BOX 37993 , CHARLOTTE, NC 28237-7992
                      </p>
                      <p>
                        to whom the account has been assigned solely for
                        collection
                        <br />
                        and to whom notice must be given of any
                        merchandise
                        <br />
                        returns or claims.Payment made to any other party
                        does
                        <br />
                        not constitute valid payment of this invoice.
                      </p>
                    </MyCard>
                  </td>
                  <td width="33.33%" style={{ height: 0, verticalAlign: "top" }}>
                    <MyCard heading="Customer Wire Payment To:">
                      <p>
                        Citibank, N.A., Canadian Branch
                        <br />
                        Address : 123 Front Street West Toronto, Ontario M5J 2M
                        <br />
                        Routing No : Bank Number - 328
                        <br />
                        Branch No : 20012
                        <br />
                        Switch Code : CITICATTBCH
                        <br />
                        Account Name : The CIT Group/Commercial Services
                        <br />
                        Account Number : 2017317028
                        <br />
                        Reference : DLPD Canada Ltd.
                      </p>
                    </MyCard>
                  </td>
                  <td width="33.33%" style={{ height: 0, verticalAlign: "top" }}>
                    <MyCard heading="Terms & Conditions">
                      <p>
                        1) No Return of goods after 45 days of shipment.
                        <br />
                        2) Damaged goods must be returned within 10 days of
                        shipment.
                        <br />
                        3) No Returns will be accepted without RA#.
                        <br />
                        4) Payments must be received within due date.
                        <br />
                        5) All Overdue invoices will be charged @1.8% per month.
                        <br />
                        6) No Return allowed on sale item.
                        <br />
                        7) Returns without an advance shipping notice (including tracking#) and an approved RA# will not be processed.
                      </p>
                    </MyCard>
                  </td>
                </tr>
                : <></>
          }
        </tbody>
      </table>
    </div>
  )
}

export default SalesInvoiceReportFooter;

const MyCard = ({ heading, children }) => (
  <div className="__card">
    {heading && <h4
      style={{
        display: "flex",
        justifyContent: "center",
        textDecoration: "underline",
      }}
    >{heading}</h4>}
    {children}
  </div>
)